'use strict';

import { resetCoordinate } from '../main';
import { anchor } from './_anchor';
import { inArray } from 'jquery';
import jqueryCSV from 'jquery-csv';
import slick from 'slick-carousel';

export const csv = (() => {

    /**
     * init
     */
	const init = () => {
		loadCSV('./assets/data/products_shirts.csv', 'coordination', 'shirts', () => {
			loadCSV('./assets/data/products_pants.csv', 'coordination', 'pants', () => {
				resetCoordinate();
			});
		});

		loadCSV('./assets/data/shoplist.csv', 'shop', '', () => {
			anchor.init();
			$('.js-accordion').on('click', function(event) {
				const $this = $(event.currentTarget);
				$this.toggleClass('is-active');
				$this.next().slideToggle(300);
			});
		});
	};

    /**
     * loadCSV
     */
    const loadCSV = (csv, container, type, callback) => {
        $.ajax({
            url: csv,
        })
        .done((data) => {
			const arrayData = $.csv.toArrays(data);
			arrayData.shift();
			container === 'coordination' ? outputCoordination(arrayData, type) : outputShop(arrayData);
			callback();
        })
        .fail((jqXHR) => {
            console.error(jqXHR.responseText);
        });
    };

    /**
     * outputCoordination
     */
	const outputCoordination = (arrayData, type) => {
		$.each(arrayData, function(index, value) {
			const category = value[1];
			const number = value[2];
			const name = value[3];
			const url = value[4];
			const images = [
				{ color: value[5], cord: value[6], image: value[7] },
				{ color: value[8], cord: value[9], image: value[10] },
				{ color: value[11], cord: value[12], image: value[13] },
				{ color: value[14], cord: value[15], image: value[16] }
			];

			let gender = category === 'ユニ・メンズ' ? 'men' : 'women';
			const id = `${gender}-${type}-${index}`;

			const elementImage = images.filter(img => img.image).map((img, i) => {
				return `<img src="./assets/img/${img.image}" width="344" height="392" id="${id}-${i + 1}" class="${i === 0 ? 'is-active' : ''}" alt="${name} ${img.color}" loading="lazy" decoding="async">`;
			}).join('');

			const elementHeading = `<h3>${name}/${number}</h3>`;

			const elementDetail = `
				<div class="detail-coordinate" id="more${id}">
					<div class="detail-coordinate__inner">
						<div class="detail-coordinate__more">
							<div class="detail-coordinate__more-inner">
								<button class="glitch-text js-more" type="button" data-more="${id}">
									<div class="glitch-text__inner">
										<div>COLOR</div>
										<div><span>COLOR</span></div>
										<div><span>COLOR</span></div>
										<div><span>COLOR</span></div>
										<div><span>COLOR</span></div>
										<div><span>COLOR</span></div>
									</div>
								</button>
							</div>
						</div>
					</div>
					<div class="detail-coordinate__close">
						<button class="glitch-text glitch-text--bg-black js-more" type="button" data-more="${id}">
							<div class="glitch-text__inner">
								<div>CLOSE</div>
								<div><span>CLOSE</span></div>
								<div><span>CLOSE</span></div>
								<div><span>CLOSE</span></div>
								<div><span>CLOSE</span></div>
								<div><span>CLOSE</span></div>
							</div>
						</button>
					</div>
					<div class="detail-coordinate__content">
						<div class="detail-coordinate__content-inner">
							<div class="detail-coordinate__item">
								<p class="detail-coordinate__text">COLORS</p>
								<ul class="list-color">
									${images.filter(img => img.image).map((img, i) => `<li class="list-color__item js-color ${i === 0 ? 'is-active' : ''}" data-color="${id}-${i + 1}"><span style="background-color: ${img.cord}"></span></li>`).join('')}
								</ul>
							</div>
							<div class="detail-coordinate__item">
								<p class="detail-coordinate__text">ONLINE SHOP</p>
								<div class="detail-coordinate__link">
									<a class="glitch-text" href="${url}" target="_blank">
										<div class="glitch-text__inner">
											<div>詳細はこちら</div>
											<div><span>詳細はこちら</span></div>
											<div><span>詳細はこちら</span></div>
											<div><span>詳細はこちら</span></div>
											<div><span>詳細はこちら</span></div>
											<div><span>詳細はこちら</span></div>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			`;

			$('#tab-' + gender + ' #' + type + '-' + gender)
			.append(`<div class="coordinate__carousel-item">${elementHeading}<figure>${elementImage}</figure>${elementDetail}</div>`);
		});
	};

    /**
     * outputShop
     */
    const outputShop = (arrayData) => {
		let arrayArea = [];
		let arrayPrefecture = [];

		$.each(arrayData, function(index, value) {
			const name = value[1];
			const area = value[2];
			const prefecture = value[3];
			const address = value[4];
			const tel = value[5];

			if (inArray(area, arrayArea) === -1) {
				arrayArea.push(area);
				arrayPrefecture.push(prefecture);

				const indexArea = inArray(area, arrayArea);
				const indexPrefecture = inArray(prefecture, arrayPrefecture);

				const anchorOrHokaidou = area === '北海道' ? '' : `
					<ul class="list-anchor">
						<li class="list-anchor__item"><a href="#prefecture${indexPrefecture}">${prefecture}</a></li>
					</ul>
				`;
				const elementHead = `
					<div class="list-area__head js-accordion">
						<h3 class="list-show__heading">${area}</h3>
					</div>
				`;
				const elementContent = `
					<div class="list-area__content" id="prefecture${indexPrefecture}">
						<h4 class="list-area__subheading">${prefecture}</h4>
						<ul class="list-shop">
							<li class="list-shop__item"><strong>${name}</strong><br>${address}<br>${tel}</li>
						</ul>
					</div>
				`;
				const elementHokaidou = `
					<li class="list-area__item" id="area${indexArea}">
						${elementHead}
						<div class="list-area__body">${elementContent}</div>
					</li>
				`;
				const elementFirstArea = `
					<li class="list-area__item" id="area${indexArea}">
						${elementHead}
						<div class="list-area__body">${anchorOrHokaidou}${elementContent}</div>
					</li>
				`;

				$('#shoplist-container').append(area === '北海道' ? elementHokaidou : elementFirstArea);

			} else if (inArray(prefecture, arrayPrefecture) === -1 && name) {
				arrayPrefecture.push(prefecture);

				const indexArea = inArray(area, arrayArea);
				const indexPrefecture = inArray(prefecture, arrayPrefecture);

				const elementAnchor = `<li class="list-anchor__item"><a href="#prefecture${indexPrefecture}">${prefecture}</a></li>`;
				const elementArea = `
					<div class="list-area__content" id="prefecture${indexPrefecture}">
						<h4 class="list-area__subheading">${prefecture}</h4>
						<ul class="list-shop">
							<li class="list-shop__item"><strong>${name}</strong><br>${address}<br>${tel}</li>
						</ul>
					</div>
				`;

				$(`#area${indexArea} .list-anchor`).append(elementAnchor);
				$(`#prefecture${indexPrefecture - 1}`).after(elementArea);

			} else if (name) {
				const indexPrefecture = inArray(prefecture, arrayPrefecture);
				const elementShop = `<li class="list-shop__item"><strong>${name}</strong><br>${address}<br>${tel}</li>`;

				$(`#prefecture${indexPrefecture} .list-shop`).append(elementShop);
			}
		});
    };

    // public
    return {
        init: init
    };
})();
